import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { HiOutlineArrowUp } from 'react-icons/hi';
import { motion, AnimatePresence } from 'framer-motion';
import './FloatingButtons.css';

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="floating-buttons">
      <AnimatePresence>
        {showTop && (
          <motion.button
            className="floating-buttons__item floating-buttons__top"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Scroll to top"
          >
            <HiOutlineArrowUp />
          </motion.button>
        )}
      </AnimatePresence>

      <a
        href="https://wa.me/919886666844"
        target="_blank"
        rel="noreferrer"
        className="floating-buttons__item floating-buttons__whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <Link to="/contact" className="floating-buttons__book btn btn-gold">
        Book Now
      </Link>
    </div>
  );
}
